<template>
  <div>
    <label class="block text-sm font-bold mb-2 mt-4" for="name">
      Name <span class="text-red-500">*</span>
    </label>

    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <ValidationProvider
        rules="required"
        name="name"
        v-slot="{ errors }"
      >
        <input
          name="name"
          type="text"
          id="name"
          class="form-control"
          autocomplete="off"
          v-model="jobType.name"
        >
        <span class="text-sm text-red-500">{{ errors[0] }}</span>
      </ValidationProvider>
    </ValidationObserver>

    <div class="flex justify-end">
      <button type="button" class="btn btn-green px-4 py-2 mt-4" @click="save">
        <i class="fas fa-check"></i>
        <span class="ml-2">{{ mode === 'edit' ? 'Update' : 'Save' }}</span>
      </button>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    jobTypeID: {},
  },
  data() {
    return {
      editID: null,
      mode: null,
      jobType: this.emptyJobType()
    }
  },
  watch: {
    jobTypeID() {
      this.setMode()
    }
  },
  mounted() {
    this.setMode()
  },
  methods: {
    setMode() {
      const name = this.$route.name.split('.')
      if (name[0] === 'jobType' && name[1]) {
        this.mode = name[1]
      } else {
        this.mode = 'create'
      }

      if (this.jobTypeID) {
        this.editID = this.jobTypeID
        this.mode = 'edit'
      } else if (this.$route.params.jobTypeID) {
        this.editID = this.$route.params.jobTypeID
      }

      if (this.mode === 'create') {
        this.jobType = this.emptyJobType()
      } else {
        this.get()
      }
    },
    set(name) {
      this.jobType.name = name
    },
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$notify({type: 'error', title: 'Form has errors'})
        return
      }
      this._save()
    },
    _save() {
      // create / update
      if (this.mode === 'create') {
        axios.post('job-types', this.jobType)
          .then((response) => {
            const newJobType = response.data
            this.$emit('created', newJobType)

            if (this.createAlert) {
              this.$swal.fire({
                title: 'Done',
                text: 'Job type created successfully!',
                type: 'success',
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (this.mode === 'edit') {
        axios.put('job-types/' + this.editID, this.jobType)
          .then(() => {
            this.$swal.fire({
              title: 'Done',
              text: 'Job type updated successfully!',
              type: 'success',
            })
            this.get()
            this.$emit('updated', this.jobType)
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    get() {
      return new Promise((resolve, reject) => {
        axios.get('job-types/' + this.editID)
          .then((response) => {
            const jobType = response.data
            this.jobType = Object.assign({}, jobType)
            resolve(jobType)
          })
          .catch((error) => reject(error))
      })
    },
    emptyJobType() {
      return {
        name: ''
      }
    }
  }
}
</script>
